import {Select} from "./Select.js";

export class HopeUserCountSelect extends Select {
    template() {
        const {addClassName = ""} = this.$props;
        return `
            <i class="sign-icons-arrow-mini"></i>
              <select id="hopeCountSelect" class="join-select-input ${addClassName}" 
                  data-required-yn="Y" 
                  data-empty-msg="${i18next.t(login.selectCompanyCategory)}">>
                    ${this.getOptionsTemplate()}
              </select>
              <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
              </p>`
    }

    getOptionsDataArr() {
        return[
            {value: "", text: `${i18next.t(login.expectMember)}`},
            {value: "10", text: `${i18next.t(login.countBelow, {count : 10})}`},
            {value: "11", text: `${i18next.t(login.countBetween, {above : 10, below : 30})}`},
            {value: "31", text: `${i18next.t(login.countBetween, {above : 31, below : 50})}`},
            {value: "31", text: `${i18next.t(login.countBetween, {above : 51, below : 99})}`},
            {value: "100", text: `${i18next.t(login.countOver, {count : 100})}`},
            {value: "500", text: `${i18next.t(login.countOver, {count : 500})}`},
            {value: "1000", text: `${i18next.t(login.countOver, {count : 1000})}`},
        ];
    }
    getQuerySelectorOfSelect() {
        return `#hopeCountSelect`
    }


}